import * as React from 'react'

interface WishButtonProps {
  style?: React.CSSProperties
  onClick?: () => void
}

const WishButton: React.SFC<WishButtonProps> = ({ children, style, onClick }) => {
  return (
    <button
      onClick={onClick}
      style={{
        width: '100%',
        backgroundColor: 'white',
        height: '40px',
        border: '1px solid #BCBCBC',
        boxSizing: 'border-box',
        borderRadius: '5px',
        fontWeight: 'bold',
        fontSize: 16,
        ...style,
      }}
    >
      {children}
    </button>
  )
}

export default WishButton



// WEBPACK FOOTER //
// ./src/components/buttons/WishButton.tsx